/**
 * Mask component.
 * Since several components (ie modal, siteHeader) use a mask in combination with the `is-clipped` class,
 * This avoids the `is-clipped` class being removed when other keys might still be active.
 *
 * Methods:
 *
 * registerFor(): register the mask toggler for a specific class
 * toggleFor(): toggle the mask for a specific class
 */

const keys = [];

const registerFor = function(theClass) {
	keys.push(theClass);
};

const toggleFor = function(theClass, bool) {
	const html = document.querySelector('html');
	if (bool === undefined) {
		// eslint-disable-next-line no-param-reassign
		bool = !html.classList.contains(theClass);
	}
	// First toggle theClass
	if (bool) {
		html.classList.add(theClass);
	} else {
		html.classList.remove(theClass);
	}
};

module.exports = {
	registerFor,
	toggleFor
};
